<template>
  <div class="enterpriseAndCommonality">
    <el-dialog
      width="600px"
      title="审批信息"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
      show-close
    >
      <div class="AddSupplierA">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="contactsForm"
        >
          <el-row style="margin-top: 10px">
            <el-col :span="18">
              <el-form-item
                label="选择评定年份："
                prop="scoreYear"
                label-width="140px"
              >
                <el-select
                  v-model="searchForm.scoreYear"
                  filterable
                  default-first-option
                  placeholder="请选择"
                  @change="changeYear"
                >
                  <el-option
                    :label="item.label"
                    :value="item.name"
                    v-for="(item, index) in yearList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="AddSupplierATitle">主管部门综合评分</div>
          <div class="AddSupplierAContent">
            <el-row>
              <el-col :span="20">
                <el-form-item
                  label="综合评定意见："
                  prop="dutyDeptComment"
                  label-width="140px"
                >
                  <el-radio v-model="ruleForm.dutyDeptComment" label="1"
                    >同意</el-radio
                  >
                  <el-radio v-model="ruleForm.dutyDeptComment" label="0"
                    >不同意</el-radio
                  >
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item
                  label="描述："
                  label-width="140px"
                  prop="dutyDeptCommentDesc"
                >
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="ruleForm.dutyDeptCommentDesc"
                    maxlength="200"
                    size="medium"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <div class="bottomBtn">
          <el-button type="primary" @click="submitBtn('ruleForm')"
            >保 存</el-button
          >
          <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierEvaluateDetailService, //查询供应商评分详情
  saveMSupplierEvaluateInfo,
} from "@/services/supplierMagServices";
export default {
  name: "AddSupplierA",
  data() {
    return {
      isDialogShow: false, //弹窗是否可见
      editFlag: true,
      RouteParam: {}, //存储路由跳转参数
      yearList: [],
      supplierId: 0, //总包合同ID
      dialogVisible: false, //预览图片是否异步
      dialogImageUrl: "", //预览图片的路径
      workPhone: "",
      legalPerson: "",
      searchForm: {
        contractId: null,
        projectId: null,
        scoreYear: new Date().getFullYear(),
        supplierId: null,
      },
      ruleForm: {
        id: "", //id
        contractId: null,
        projectId: null,
        supplierId: null,
        dutyDeptComment: "1", //dutyDeptComment
        dutyDeptLevelDisplayName: "", //dutyDeptLevelDisplayName
        dutyDeptCommentDesc: "", //dutyDeptCommentDesc
        scoreYear: new Date().getFullYear(),
      },

      rules: {
        dutyDeptComment: [
          { required: true, message: "请选择综合评定意见", trigger: "blur" },
        ],
        scoreYear: [
          { required: true, message: "请选择评定年份", trigger: "blur" },
        ],
      },
      isShopNameBool: false,
    };
  },
  mounted() {
    this.getYears();
  },
  methods: {
    //获取一条生产部门评价信息
    getSupplierEvaluateDetail(id) {
      getSupplierEvaluateDetailService(this.searchForm)
        .then((res) => {
          if (res.code == 10000000) {
            this.ruleForm = res.data;
            this.ruleForm.dutyDeptComment =
              res.data.dutyDeptComment == 0 ? "0" : "1";
            // this.ruleForm.dutyDeptCommentDesc = res.data.dutyDeptCommentDesc || "";
          } else if (res.code == 60010013) {
            this.ruleForm={}
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },

    showDialog(row) {
      this.ruleForm.id = row.id;
      this.searchForm.contractId = row.contractId;
      this.searchForm.projectId = row.projectId;
      this.searchForm.scoreYear = row.scoreYear || new Date().getFullYear();
      this.searchForm.supplierId = row.supplierId;
      this.isDialogShow = true;
      this.ruleForm = {
        id: "", //id
        contractId: this.searchForm.contractId,
        projectId: this.searchForm.projectId,
        supplierId: this.searchForm.supplierId,
        dutyDeptComment: "1", //dutyDeptComment
        dutyDeptLevelDisplayName: "", //dutyDeptLevelDisplayName
        dutyDeptCommentDesc: "", //dutyDeptCommentDesc
        scoreYear: this.searchForm.scoreYear,
      };
      this.getSupplierEvaluateDetail();
    },
    changeYear(value) {
      this.searchForm.scoreYear = value;
      this.ruleForm.scoreYear = value;
      this.getSupplierEvaluateDetail();
    },

    //提交
    submitBtn(formName) {
      if (!this.ruleForm.score||!this.ruleForm.id) {
        this.$message.warning("请先完成该年份生产部门评价。");
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editFlag) {
            //更新
            // this.ruleForm.dutyDeptCommentDesc=parseInt(this.ruleForm.dutyDeptCommentDesc)
            saveMSupplierEvaluateInfo(this.ruleForm).then((res) => {
              if (res.code == 10000000) {
                this.$refs.ruleForm.clearValidate();
                this.$emit("close");
                this.isDialogShow = false;
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //获取年份
    getYears(num = 7) {
      // 存储年份数据的数组
      let list = [];
      // // 获取前一年的数据
      // const prevYear = {
      //   name: Number(`${currentYear - 1}`),
      //   label: `${currentYear - 1}年`
      // };
      // list.push(prevYear);
      // 获取当前年份
      const currentYear = new Date().getFullYear();
      list.push({
        name: Number(`${currentYear}`),
        label: `${currentYear}年`,
      });
      // 获取后面几年的数据
      for (let i = 1; i <= num; i++) {
        const nextYear = {
          name: Number(`${currentYear - i}`),
          label: `${currentYear - i}年`,
        };
        list.push(nextYear);
      }
      this.yearList = list;
    },
  },
};
</script>

<style scoped lang="scss">
.enterpriseAndCommonality {
  background-color: white;

  // height: 100%;
}
/deep/.el-table .cell {
  white-space: pre-line;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}

/deep/.el-popover {
  padding: 24px;
}

.AddSupplierA {
  width: 100%;
}
@media only screen and(max-width:1680px) {
  .AddSupplierA {
    width: 100%;
  }
}
.AddSupplierA {
  background: rgba(255, 255, 255, 1);
  .el-form-item {
    width: 100%;
  }
  /deep/.cell .el-form-item__content {
    margin-left: 10px !important;
  }
  /deep/.el-form-item {
    margin-bottom: 20px;
  }

  .el-checkbox {
    line-height: 40px;
  }

  .el-textarea {
    min-width: 0px !important;
  }
  .el-cascader {
    width: 100%;
  }

  .el-form-item__content {
    width: calc(100% - 110px);
    line-height: 20px;

    .el-input {
      width: 100%;
    }
    .el-select {
      width: 100%;
    }
  }
  .bottomBtn {
    // border-top: 1px solid #e6e6e6;
    width: 90%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    margin-bottom: 20px;
  }
  .AddSupplierATitle {
    height: 44px;
    padding-left: 24px;
    box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
    border-radius: 2px 2px 0px 0px;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 44px;
    text-align: left;
  }
  .AddSupplierAContent {
    padding: 14px 8px;
  }
  /deep/.daterangePicker {
    width: 255px;
    height: 32px;
    .el-input__icon {
      display: flex;
      align-items: center;
    }
    .el-range-separator {
      display: flex;
      align-items: center;
    }
  }
}
</style>
